module.exports = __webpack_public_path__ + "static/img/emoji_sprite.e3d563bb.png";